<template>
  <article class="example-page">
    <h1>Context Menu</h1>
    <form>
      <label for="position">Desktop position</label>
      <select id="position" v-model="positionData" placeholder="Position">
        <option value="top-left">Top-Left</option>
        <option value="top-right">Top-Right</option>
        <option value="right">Right</option>
        <option value="bottom-left">Bottom-Left</option>
        <option value="bottom-right">Bottom-Right</option>
        <option value="left">Left</option>
      </select>
      <label for="content">Content</label>
      <textarea id="content" v-model="contentData" placeholder="Content" />
    </form>
    <div class="menu-container">
      <context-menu :displayed="displayedData" :position="positionData" @close="close">
        <button slot="anchor" type="button" class="menu-toggle" @click="toggle">Toggle</button>
        <!-- eslint-disable vue/no-v-html -->
        <ul slot="content" v-html="contentData" />
        <!-- eslint-enable vue/no-v-html -->
      </context-menu>
    </div>
  </article>
</template>

<script>
import { contextMenu } from '@/components/layout';
import animations from '@/lib/utils/animations';

export default {
  components: { 'context-menu': contextMenu },
  data() {
    return {
      displayedData: false,
      positionData: 'bottom-right',
      anchorData: '<button type="button">Toggle</button>',
      titleData: 'Title',
      contentData:
`<li><a @click="animateMenu" @animationend="unanimateMenu" href="#">Context menu item</a></li>
<li><a @click="animateMenu" @animationend="unanimateMenu" href="#">Another longer context menu</a></li>
<li><a @click="animateMenu" @animationend="unanimateMenu" href="#">Regular sized one</a></li>
<li><a @click="animateMenu" @animationend="unanimateMenu" href="#">Small one</a></li>
<li><a @click="animateMenu" @animationend="unanimateMenu" href="#">And a last one for fun</a></li>`,
    };
  },
  methods: {
    animateMenu(event) {
      animations.flashOrFill(event);
      setTimeout(() => {
        this.close();
      }, 200);
    },
    unanimateMenu: animations.unflashOrFill,
    toggle() {
      this.displayedData = !this.displayedData;
    },
    close() {
      this.displayedData = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-container {
  margin: 1rem auto 0;
  width: fit-content;
}

.context-menu-list {
  li {
    border-top: 1px solid $pearl-500;
    white-space: nowrap;
  }

  li > * {
    display: block;
    padding: 0.7rem 0;
  }

  li a {
    color: $black;
    text-decoration: none;
  }

  li a:hover {
    color: $black;
  }

  @media #{$screen-width-small} {
    li {
      border-top: none;
      border-radius: 0.2rem;
    }

    li a:hover {
      background-color: rgba($primary-100, 0.1);
      color: $primary-300;
    }

    li > * {
      padding: 0.3rem 0.2rem;
    }
  }
}
</style>
